import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';

@Injectable({
  providedIn: 'root',
})
export class CompanyOnboardingService {
  private readonly apiService = inject(ApiService);

  registerCompany(formData: FormData): Observable<ApiResponse<any>> {
    return this.apiService.postWithSuperAdminToken('user/auth/register', formData);
  }
}
